import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type CategoryByIdData = AnyObject

export type CategoryByIdResponse = CategoryByIdData

export interface CategoryById {
  id: string;
}

export const categoryById = (payload: CategoryById): Action<CategoryById> => ({
  type: actions.categoryByIdTrigger.toString(),
  payload,
});

export const categoryByIdClear = (): Action => ({
  type: actions.categoryByIdClear.toString(),
});

export function* categoryByIdRequestSaga({ payload }: Action<CategoryById>) {
  yield put({
    type: actions.categoryByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.categoryByIdError.toString(),
      payload: {
        message: 'CategoryById: Parameters not passed.',
      },
    });

    return;
  }

  const { id, ...params } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}admin/categories/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        params: new URLSearchParams(params).toString(),
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CategoryByIdData, CategoryByIdResponse>(
    response,
    actions.categoryByIdSuccess.toString(),
    actions.categoryByIdError.toString(),
    false,
    (categoryByIdData) => categoryByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.categoryByIdTrigger.toString(),
    defaultProcessingSaga(
      categoryByIdRequestSaga,
      {
        error: actions.categoryByIdError.toString(),
        locationCancel: actions.categoryByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.categoryByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.categoryByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.categoryByIdErrorReset.toString(),
    });
  });
}
